<template>
  <div class="mainContent helpContent">
    <pageHead device="desktop" page="about02" :title="$t('store.about_title01')"/>
    <div class="rule container about">
      <h1 class="title lkrule"><span>{{ $t("store.about_title01") }}</span></h1>

      <section class="rule-cont" v-for="(item, index) in About02" :key="index">
        <div class="title" v-html="item.title"></div>
        <div v-html="item.description"></div>
      </section>

    </div>
  </div>
</template>
<script>
  import { getJsonFile } from '@/utils/jsonFile';
  import pageHead from "~/components/common/pageHead.vue";
  export default {
      components: { pageHead },
      computed: {
        About02() {
          return getJsonFile(process.env.DEF_webStyle, 'about02');
        },
        HasX() {
          return Object.keys(this.$route.query).indexOf('x') >= 0;
        },
        Title() {
          return this.$t("store.about_title01") + (this.HasX ? ' - ' + process.env.WEB_TITLE : '');
        }
      }
    };
</script>
